import { config } from '@config';
import { findLocationSearch } from '@utils/location-search';
import { defineModel } from 'foca';

const initialState: {
  coinTypeA: string;
  coinTypeB: string;
} = {
  coinTypeA:
    config.sui_network === 'mainnet'
      ? '0x5145494a5f5100e645e4b0aa950fa6b68f614e8c59e17bc5ded3495123a79178::ns::NS'
      : '0x541826891e877178df82f2df2996599618a259e719ef54a8e1969211c609cd21::turbos::TURBOS',
  coinTypeB:
    config.sui_network === 'mainnet'
      ? '0x5145494a5f5100e645e4b0aa950fa6b68f614e8c59e17bc5ded3495123a79178::ns::NS'
      : '0x2::sui::SUI',
};

export const swapCoinModel = defineModel('swap-coin', {
  initialState,
  reducers: {
    updateA(state, coinType: string) {
      state.coinTypeA = coinType;
    },
    updateB(state, coinType: string) {
      state.coinTypeB = coinType;
    },
    exchange(state) {
      return {
        coinTypeA: state.coinTypeB,
        coinTypeB: state.coinTypeA,
      };
    },
  },
  events: {
    onInit() {
      const hash = window.location.hash.replace(/.*\?/, '');
      const search = window.location.search.replace(/^\?/, '');
      if (search) {
        const input = findLocationSearch(search, 'from');
        const output = findLocationSearch(search, 'to');
        if (input) {
          this.updateA(input);
        }
        if (output) {
          this.updateB(output);
        }
      } else if (hash) {
        const input = findLocationSearch(hash, 'from');
        const output = findLocationSearch(hash, 'to');
        if (input) {
          this.updateA(input);
        }
        if (output) {
          this.updateB(output);
        }
      }
    },
  },
});
